export enum ELanguage {
  en = 'en',
  tr = 'tr',
  de = 'de',
  es = 'es',
  fr = 'fr',
  it = 'it',
  pl = 'pl',
  ja = 'ja',
  ko = 'ko',
  sr = 'sr',
}
